import { ConflictDialog } from "@components/QaReview/components/ConflictDialog";
import { SuggestEditDialogHost } from "@components/QaReview/components/SuggestEditDialogHost";
import { useReviewSession } from "@components/QaReview/hooks/useReviewSession";

export const ReviewDialogs: React.FC = () => {
  const { state } = useReviewSession();

  return (
    <>
      {state.conflictCommentId && <ConflictDialog />}
      {state.suggestEditFieldId && <SuggestEditDialogHost />}
    </>
  );
};
